import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";
import convertToExcel from "../../../components/ExportToExcel";

const RateCardDetailsList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);

  const { sendRequest: getDataList } = useHttp();

  const FillDetail = () => {
    getDataList(
      {
        url: "/api/gradeRateCard/",
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, gradeId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Rate Card detail?",
      onOk() {
        deleteOperation(
          {
            url: `/api/gradeRateCard/?orgId=${localStorage.getItem(
              "orgId"
            )}&createdBy=${parseInt(
              localStorage.getItem("id")
            )}&gradeId=${gradeId}`,
            method: "DELETE",
          },
          (data) => {
            toast.success("Data Deleted Successfully");
            FillDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.cropName.toLowerCase().includes(filetrtext) ||
        item.varietyName.toLowerCase().includes(filetrtext) ||
        item.unitAbbreviation.toLowerCase().includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedGrade, setSelectedGrade] = useState([]);
  const openModal = (data) => {
    //  console.log(data);
    const dNo = data && data.docNo;
    setSelectedData(data);

    if (dNo) {
      getDataList(
        {
          url: `/api/gradeRateCard/?docNo=${dNo}`,
        },
        (res) => {
          if (res) {
            console.log("gradeRateCard", res);
            setSelectedGrade(res);
          }
        }
      );
    }

    setIsModalOpen(true);
  };

  const fieldsToExport = [
    "gradeRateCardDate",
    "docNo",
    "cropName",
    "varietyName",
    "quantity",
    "unitAbbreviation",
    "currency"
    
  ];

  const customHeaders = [
    "Date",
    "Doc No",
    "Crop Name",
    "Variety Name",
    "Quantity",
    "Unit",
    "Currency",
  ];

  const handleExportExcel = () => {
    const filename = "RateCardDetailsReport.xlsx";
    //console.log(fieldsToExport,customHeaders);

    const transformedData =
      data &&
      data.map((item) => ({
        ...item,

        currency: localStorage.getItem("currencyCode") || "",
      }));
    console.log(transformedData);

    convertToExcel(transformedData, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Rate Card Detail{" "}
            </label>{" "}
          </div>
          <div className="col-4"> </div>
          <div className="col-2">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Rate Card
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row ">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row text-right">
                      <div className="col-12">
                        <div className="">
                          <button
                            type="button"
                            className="btn btn-sm btn-warning"
                            onClick={handleExportExcel}
                          >
                            <i className="fas fa-file-excel"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Doc No</th>
                            <th>Crop Name</th>
                            <th>Variety Name</th>
                            <th>Quantity</th>
                            <th>Unit</th>
                            <th>Currency</th>
                            <th>Edit</th>
                            <th>View</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.gradeRateCardDate}</td>
                                <td>{x.docNo}</td>
                                <td>{x.cropName}</td>
                                <td>{x.varietyName}</td>
                                <td>{x.quantity}</td>
                                <td>{x.unitAbbreviation}</td>
                                <td>
                                  {localStorage.getItem("currencyCode") || ""}
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(x)}
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Rate Card Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Crop Type: {selectedData.vendorCode}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Crop Name: {selectedData.cropName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Variety Name: {selectedData.varietyName}
              </p>
              <p className="col-md-6">
                Quantity :{" "}
                {selectedData.quantity + " " + selectedData.unitAbbreviation}
              </p>
            </div>
            <h5 className="card-title">Grade Details</h5>
            <table className="table tabel-sm text-center table-bordered">
              <thead>
                <tr>
                  <th>Grade</th>
                  <th>Rate</th>
                </tr>
              </thead>
              <tbody>
                {selectedGrade &&
                  selectedGrade.map((x, i) => (
                    <tr key={i}>
                      <td>{x.gradeName}</td>
                      <td>{x.rate}</td>
                    </tr>
                  ))}
              </tbody>
            </table>{" "}
            {/**/}
          </div>
        )}
      </Modal>
    </>
  );
};

export default RateCardDetailsList;
